(function () {
    'use strict';

    angular
        .module('invesfleet')
        .directive('modal', modal);

    modal.$inject = [];

    function modal() {
        // Usage:
        //     <modal close-on-click-outside="true" show="$scope.variable"> contenido </modal>
        // Creates:
        // 
        var directive = {
            restrict: 'E',
            transclude: true, 
            replace: true,
            templateUrl: 'app/views/directives/modal.html',
            scope: {
                show: '=',
                closeOnClickOutside: '=?'
            }
        };
        return directive;
    }
})();